import React, { useCallback, useMemo } from 'react';
import { Badge } from 'components/shadcn/ui/badge';

const HGStatus = ({ online, hasAlarm, hasFault, ...rest }) => {
    const getStatusColorAndContent = useCallback(() => {
        if (hasFault) return { color: 'error', content: 'fault' };
        if (hasAlarm) return { color: 'warning', content: 'alarm' };
        if (online === 'online' || online === true) return { color: 'success', content: 'online' };
        if (online === 'offline' || online === false) return { color: 'error', content: 'offline' };
        return { color: 'secondary', content: 'loading' };
    }, [online, hasAlarm, hasFault]);

    const { color, content } = useMemo(
        () => getStatusColorAndContent(),
        [getStatusColorAndContent]
    );

    return (
        <Badge color={color} circular {...rest}>
            {content}
        </Badge>
    );
};

export default HGStatus;
